import React from 'react';
import { withRouter } from 'react-router-dom';
import { Box, Button } from 'fw/components';

class NotFoundError extends React.Component {
    goBack = () => {
        if (this.props.backUrl != null) {
            this.props.history.push(this.props.backUrl);
        }
        else {
            // Move 2 entries back
            this.props.history.go(-2);
        }
    }

    goHome = () => {
        if (this.props.homeUrl != null) {
            this.props.history.push(this.props.homeUrl);
        }
        else {
            this.props.history.push("/");
        }
    }

    render() {
        return (
            <Box boxStyle="primary" className="text-center">
                <h4>{this.props.message}</h4>
                <hr />
                <p> If the problem persist, please contact an administrator.</p>
                <div className="btn-toolbar">
                    <Button id="btnGoHome" onClick={this.goHome}>Go Home</Button>
                    {!this.props.hideBack &&
                        <Button id="btnGoBack" onClick={this.goBack}>Go back</Button>}
                </div>
            </Box>
        );
    }
}

export default withRouter(NotFoundError);

NotFoundError.defaultProps = {
    message: "The element you are looking for was not found."
};


// WEBPACK FOOTER //
// ./src/areas/shared/pages/setup/NotFoundError.js